import * as Utils from './utilities'
const TweenLite = window.TweenLite;
const Power3 = window.Power3;

const MENU_CLASS = 'menu-open';
const topBar = document.querySelector('.top-bar');

let topBarHeight;

const showMobileMenu = (e) => {
  e.preventDefault();
  topBarHeight = topBar.offsetHeight;
  Utils.addClass( document.body, MENU_CLASS);
  TweenLite.to( topBar, 0.5, {
    height: window.innerHeight,
    ease: Power3.easeOut
  });
};

const hideMobileMenu = (e) => {
  e.preventDefault();
  Utils.removeClass( document.body, MENU_CLASS);
  TweenLite.to( topBar, 0.5, {
    height: topBarHeight,
    ease: Power3.easeOut
  });
};

document.querySelector( '.mobile-menu--open' ).addEventListener( 'click', showMobileMenu);
document.querySelector( '.mobile-menu--close' ).addEventListener( 'click', hideMobileMenu);


/** WEBPACK FOOTER **
 ** ./src/js/mobile-menu-opening.js
 **/